import React from "react";
import { Button, Modal } from "react-bootstrap";

import { DeleteTryoutsModalProps } from "../types/tryouts";

const DeleteTryoutsModal = ({
    show,
    setShow,
    handleDelete,
}: DeleteTryoutsModalProps): React.JSX.Element => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            data-testid="deleteTryoutsModal"
            centered
        >
            <Modal.Header>
                <Modal.Title>Delete Tryout Info?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete this tryout info?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setShow(false)}>
                    No
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteTryoutsModal;
